import z from "zod";

export const AuditedEntitySchema = z.object({
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const IdentifiedEntitySchema = z.object({
  id: z.uuidv7(),
});

export const BaseSchema = z.object({
  ...AuditedEntitySchema.shape,
  ...IdentifiedEntitySchema.shape,
});
